import { Clapperboard, FileText, PlaneTakeoff, Settings } from 'lucide-react';
import type { EnterpriseTeamSettingsRoutes } from 'v5/core/routing/appRouting';
import { NavLink } from 'v5/platform/react-router';
import { MenuItem } from 'v5/patterns/sidebar/Menu';
import { EnterpriseTeam } from 'v5/api/enterprise/enterprise.api';

/** Team settings — scoped items only; workspace menu holds the rest. */
export function renderEnterpriseTeamSettingsItems(
  _team: EnterpriseTeam,
  settings: EnterpriseTeamSettingsRoutes,
  level = 2
) {
  const routes = settings;

  return (
    <>
      <NavLink to={routes.publicProfile()}>
        <MenuItem level={level} icon={<Settings className="size-4" />}>
          General
        </MenuItem>
      </NavLink>
      <NavLink to={routes.productionTemplates()}>
        <MenuItem level={level} icon={<Clapperboard className="size-4" />}>
          Production templates
        </MenuItem>
      </NavLink>
      <NavLink to={routes.callsheetTemplates()}>
        <MenuItem level={level} icon={<FileText className="size-4" />}>
          Callsheet templates
        </MenuItem>
      </NavLink>
      <NavLink to={routes.arrivalBoard()}>
        <MenuItem level={level} icon={<PlaneTakeoff className="size-4" />}>
          Arrival board
        </MenuItem>
      </NavLink>
    </>
  );
}
